// extracted by mini-css-extract-plugin
module.exports = {"user-overview-hover-animate":"OverviewPopper_user-overview-hover-animate__p2r7c","user-overview-container":"OverviewPopper_user-overview-container__0w3rT"};